import * as types from './types'
import { dismissSystemNotifications } from '../../../api/system_notifications'

export default {
  [types.IS_ONBOARDED] (state, value) {
    state.isOnboarded = value
  },
  
  [types.SYSTEM_NOTIFICATIONS] (state, value) {
    state.systemNotifications = value
  },

  removeFromNotifications (state, value) {
    let notifications = state.systemNotifications 
    const index = notifications.indexOf(value)
    if (index > -1) {
      notifications.splice(index, 1)
    }
    const payload = [value.id]
    
    dismissSystemNotifications(payload)
  },

  removeAllNotifications(state) {
    state.systemNotifications = []
  }
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/onboarding/mutations.js
// module id = null
// module chunks = 